import { Component, Input, Output, ViewChild, EventEmitter, Renderer2 } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoggerEvent, LoggerProvider } from '../../providers/logger/logger';
import { NavParams } from 'ionic-angular';

@Component({
  selector: 'rmt-select-list',
  templateUrl: './rmt-select-list.html'
})
export class RmtSelectListComponent {
  @ViewChild('searchbar') searchbar;
  @ViewChild('scroll') scroll;
  @ViewChild('ionlist') ionlist;

  @Input() title: string;
  @Input() placeholder: string;
  @Input() useIcons: boolean = false;
  @Input() noResults: boolean = false;
  @Input() errorTitle: string = this.translate.instant('global.noResultsText');
  @Input() errorMessage: string = '';
  @Input() newDesign: boolean = false;
  @Input() isFromWallet: boolean = false;
  @Input() hideSearchbar: boolean = false;
  @Input() hideForwardArrow: boolean = false;
  @Input() borderBottom: boolean = false;
  @Input() visibleItems: any[] = [];
  @Input() items: any[] = [];
  @Input() favorites: any[] = [];
  @Input() showFavoritesOnlyOnce: boolean = false;
  @Input() showFavorites: boolean = false;
  @Input() showIcons: boolean = false;
  @Input() showListHeader: boolean = false;
  @Input() preSelectedItem: any;
  @Input() itemFieldValue: string;
  @Input() itemFieldText: string;
  @Input() itemFieldDescription: string;
  @Input() itemFieldSelectedText: string;
  @Input() itemFieldIcon: string;
  @Input() itemFieldIconPrefix: string;    
  @Input() itemFieldImage: string;
  @Input() hideHelp: boolean;
  @Input() showRightClose: boolean = false;
  @Input() supportsMostCommon: boolean = false;
  @Input() mostCommonHeaderText: string;
  @Input() moreOptionsHeaderText: string;
  @Input() idPrefix: string;

  @Output() itemSelected: EventEmitter<any> = new EventEmitter<any>();


  hasItems: boolean = false;

  private animationInProgress: boolean = false;

  searchText: string = '';
  constructor(
    private translate: TranslateService, 
    private navParams: NavParams,
    private renderer: Renderer2
  ) {}

  ngOnInit() { 
    if (this.items) {
      if (this.items.length === 0) {
        // If items are empty, we assume they will be loaded later through rmt-dynamic-form-field, ngOnInit() -> loadFieldValue()
        let tries = 0;
        setTimeout(() => {
          if (this.items && this.items.length > 0) {
            this.formatItems(this.items, this.favorites);
          }
          else if (tries < 10) {
            this.ngOnInit();
            tries++;
            return;
          } else {
            LoggerProvider.error(this, LoggerEvent.ExceptionMessage ,"SelectPicker initialized without items or itemsPromise after 10 tries.");
          }
        }, 500);
      } else {
        this.formatItems(this.items, this.favorites);
      }
    }
    else {
      this.visibleItems = []
      LoggerProvider.info(this, "SelectPicker initialized without items or itemsPromise.")
    }
    
    if(this.navParams.get('addTopMargin'))
    {
      var that = this;
      window.setTimeout(() => {   
        if(that.ionlist){
          that.ionlist.nativeElement.style.marginTop = '16px';
        }
      }, 50);
    }
  }

  formatItems(allitems, favorites) {
    if (favorites && favorites.length > 0) {
      const items = allitems;
      const values = [];
      allitems = [];

      if (favorites) {
        if (this.showListHeader && favorites && favorites.length > 0 && !favorites[0].isHeader) {
          favorites.unshift({
            text: this.translate.instant('form.moneyTransferCalculatorForm.topCountriesLabel'),
            isHeader: this.showListHeader
          })
        }

        for (let i = 0; i < favorites.length; i++) {
          const favorite = favorites[i];
          if (favorite) {
            favorite.favorite = true;
            values.push(favorite.value);
            allitems.push(favorite);
          }
        }
      }

      if (this.showListHeader && items && items.length > 0 && !items[0].isHeader) {
        items.unshift({
          text: this.translate.instant('form.moneyTransferCalculatorForm.allCountriesLabel'),
          isHeader: this.showListHeader
        })
      }
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item.favorite && this.showFavoritesOnlyOnce)
          continue;
        item.favorite = false;
        allitems.push(item);
      }
    }
    //retrieve the preSelectedItem to updater isSelected 

    for (let i = 0; i < allitems.length; i++) {
      if (allitems[i]) {
        if (allitems[i].category)
          allitems[i] = this.setIsSelectedItem('category', allitems[i]);
        else if (allitems[i].Id)
          allitems[i] = this.setIsSelectedItem('Id', allitems[i]);
        else if (allitems[i].abbreviation)
          allitems[i] = this.setIsSelectedItem('abbreviation', allitems[i]);
        else
          allitems[i] = this.setIsSelectedItem('value', allitems[i]);
      }
    }
    this.items = this.formatItemsWithParams(allitems);
    if (this.items) this.hasItems = true;
    this.onSearch();
  }

  async waitForItems(itemsPromise)  {
    let allitems = await itemsPromise;
    allitems = [].concat(allitems); // create a new array so we don't keep the reference and could accidentely modify the existing one

    let favorites: any = null;

    this.hasItems = true;
    this.formatItems(allitems, favorites);
  }

  setIsSelectedItem(itemReference: string, item: any) {
    if (this.preSelectedItem) {
      if (item[itemReference] === this.preSelectedItem.value)
        item.isSelected = true;
      else
        item.isSelected = false;
    }
    else
      item.isSelected = false;

    return item;
  }

  formatItemsWithParams(items) {
    let newitems = items;
    if (this.itemFieldValue || this.itemFieldText || this.itemFieldIcon || this.itemFieldSelectedText || this.itemFieldImage) {
      newitems = [];
      for (let i=0; i < items.length; i++) {
        const item = { ...items[i] };
        if (this.itemFieldValue)
          item.value = item[this.itemFieldValue];
        if (this.itemFieldText)
          item.text = item[this.itemFieldText];          
        if (this.useIcons && this.itemFieldIcon && item[this.itemFieldIcon]) {
          item.icon = (this.itemFieldIconPrefix + item[this.itemFieldIcon]).toLowerCase();
          if(this.itemFieldIconPrefix.indexOf('custom-icon-country') == 0) {  
            const country = item[this.itemFieldIcon];
            if (country) {
              const splitted = country.split('_');
              if (splitted && splitted.length > 0)
                item.flag = 'assets/countryFlagSvg/' + splitted[0].toUpperCase() + '.svg';
            }
          }
        }
        if (this.itemFieldSelectedText)
          item.selectedText = item[this.itemFieldSelectedText];
        if (this.itemFieldDescription)
          item.description = item[this.itemFieldDescription];
        item.img = this.itemFieldImage;

        newitems.push(item);
      }
    }    
    return newitems;
  }

  processVisibleItems(visibleItems, searchText) {
    if (visibleItems.length === 0 || searchText !== this.searchText)
      return;

    // If we're processing items with search, don't apply most common separation
    if (this.searchText) {
      for (let i=0; i < 10; i++) {      
        const item = visibleItems.shift();
        if (item)
          this.visibleItems.push(item);
        if (visibleItems.length === 0)
          return;
      }
    } else if (this.supportsMostCommon && visibleItems.length >= 8) {
      // Reset the collections
      let mostCommonItems = [];
      let moreItems = [];

      // Check if we have any displayPriority values that aren't null
      const hasPriorityItems = visibleItems.some(item => 
        item && !item.isHeader && item.displayPriority !== undefined && item.displayPriority !== null
      );
      
      if (!hasPriorityItems) {
        this.visibleItems = [...visibleItems];
        return;
      }
      
      visibleItems.forEach(item => {
        if (item && !item.isHeader) {
          if (item.displayPriority !== undefined && item.displayPriority !== null) {
            mostCommonItems.push(item);
          } else {
            moreItems.push(item);
          }
        } else if (item && item.isHeader) {
          // Keep header items in the main list for backward compatibility
          this.visibleItems.push(item);
        }
      });
      
      mostCommonItems.sort((a, b) => a.displayPriority - b.displayPriority);
      mostCommonItems = mostCommonItems.slice(0, 4);
      
      // Make all items available in the main array for backward compatibility
      this.visibleItems = [...this.visibleItems, {text: this.mostCommonHeaderText, isHeader: true}, 
        ...mostCommonItems, {text: this.moreOptionsHeaderText, isHeader: true}, ...moreItems];
      return;
    } else {
      // Standard processing without categorization
      this.visibleItems = [...visibleItems];
      return;
    }
    
    window.setTimeout(() => {      
      this.processVisibleItems(visibleItems, searchText);
    }, 50);
  }

  onSearch() {    
    this.searchText = this.searchbar && this.searchbar.searchdiv ? this.searchbar.searchdiv.value : '';

    let visibleItems = [];
    if (this.searchText) {
      visibleItems = [];
      for (let i = 0; i < this.items.length; i++) {
        const item = this.items[i];
        if (this.checkSearchText(item)) {
          if (item && item.value) {
            if (visibleItems.filter((visibleItem) => {
              return visibleItem.value == item.value
            }).length === 0)// Filter favorite duplicates in search
              visibleItems.push(item);
          }
          else if (item && item.Name) {
            if (visibleItems.filter((visibleItem) => {
              return visibleItem.value == item.Name
            }).length === 0)// Filter favorite duplicates in search
              visibleItems.push(item);
          }
        }

      }
    }
    else if (this.items && this.items.length > 0)
      visibleItems = visibleItems.concat(this.items);

    this.visibleItems = [];

    // wait until we have received the items to show no result otherwise it could happen that since we're still loading the items we would get here no visibleItems
    // but then we shouldn't show no result but still keep the content loader until the items are loaded
    if (this.hasItems && visibleItems && visibleItems.length === 0)
      this.noResults = true;
    else {
      this.noResults = false;
      this.processVisibleItems(visibleItems, this.searchText);
    }
      
    window.requestAnimationFrame(() => {
      if(this.scroll) this.scroll.update(true);
    });
  }

  checkSearchText(item) {
    if (!this.searchText) return true;
    const itemText = item.text ? item.text.toLowerCase() : '';
    const searchText = this.searchText.toLowerCase();
    return itemText.includes(searchText);
  }

  selectItem(item) {
    if (item.isHeader || this.animationInProgress) {
      return;
    }
    this.visibleItems.forEach(x => (x.isSelected = false));
    item.isSelected = true;
    
    this.animationInProgress = true;
    this.performBlinkAnimation(item).then(() => {
      this.itemSelected.emit(item);
    });
  }

  async performBlinkAnimation(item): Promise<void> {
    const itemId = this.getItemId(item.value);
    const element = document.getElementById(itemId);
    
    if (!element) {
      this.animationInProgress = false;
      return Promise.resolve();
    }
    
    const rowElement = element.querySelector('.row-highlight') || element.querySelector('ion-row');
    if (!rowElement) {
      this.animationInProgress = false;
      return Promise.resolve();
    }
    
    return new Promise<void>((resolve) => {
      this.renderer.addClass(rowElement, 'animate-select');
      
      const animationEndHandler = () => {
        rowElement.removeEventListener('animationend', animationEndHandler);
        this.renderer.removeClass(rowElement, 'animate-select');

        this.animationInProgress = false;
        resolve();
      };
      
      // Add event listener for animation end
      rowElement.addEventListener('animationend', animationEndHandler);
    });
  }

  getItemId(extra) {
    return extra ? `${this.idPrefix}-item-${extra}` : '';
  }

  calculateHeight(item) {
    if (item.isHeader) return '44px';
    else if (item.img) return '88px';
    else return '56px';
  }

  getLargeTitle() {
    return this.isFromWallet ? this.title : '';
  }
}


// WEBPACK FOOTER //
// ./src/components/rmt-select-list/rmt-select-list.ts